// Common app
export const APP_HEADER_HEIGHT = 37
export const TOP_BUTTONS_HEIGHT = 45
export const APP_PADDING = 30
export const APP_FOOTER_HEIGHT = 60
export const CONTENT_PADDING = 50
export const NAV_HEADER_HEIGHT = 45
export const NAV_HEADER_PADDING = 20

// Tab
export const TAB_HEADER_HEIGHT = 55

// Table
export const TABLE_PADDING = 16
export const PAGING_HEIGHT = 58
export const TABLE_FILTER_HEIGHT = 56

export const COMMON_OUTER_HEIGHT =
  APP_HEADER_HEIGHT +
  TOP_BUTTONS_HEIGHT +
  APP_PADDING * 2 +
  TAB_HEADER_HEIGHT +
  TABLE_FILTER_HEIGHT +
  TABLE_PADDING +
  PAGING_HEIGHT +
  APP_FOOTER_HEIGHT +
  CONTENT_PADDING

// Report page
export const REPORT_HEADER_HEIGHT = 112
export const REPORT_PADDING = 12
export const OUTER_HEIGHT_REPORT =
  REPORT_HEADER_HEIGHT + APP_FOOTER_HEIGHT + PAGING_HEIGHT + CONTENT_PADDING * 2

// Settings page
export const SETTING_HEADER_HEIGHT = 112
export const SETTING_TITLE_HEIGHT = 70

export const OUTER_HEIGHT_SETTING =
  SETTING_HEADER_HEIGHT + SETTING_TITLE_HEIGHT + APP_FOOTER_HEIGHT + CONTENT_PADDING

// Store setup page
export const STORE_SETUP_HEADER_HEIGHT = 128
export const STORE_SETUP_TITLE_HEIGHT = 70
export const STORE_SETUP_INPUT = 96
export const STORE_SETUP_PADDING = 12

// Shipment page
export const SHIPMENT_FILTER_HEIGHT = 76
export const SHIPMENT_FULL_FILTER_HEIGHT = 116
export const SHIPMENT_PADDING_HEIGHT = 12

export const OUTER_HEIGHT_SHIPMENT =
  APP_HEADER_HEIGHT +
  APP_PADDING * 2 +
  SHIPMENT_FILTER_HEIGHT +
  PAGING_HEIGHT +
  APP_FOOTER_HEIGHT +
  CONTENT_PADDING

export const TOP_ALERT_HEIGHT = 66
export const LAPTOP_MIN_WIDTH = 1240
export const TABLET_BREAKPOINT = 778
export const TABLET_MIN_WIDTH = 600
export const LAPTOP_MAX_WIDTH = 1440
export const MOBILE_BREAKPOINT = 375
export const TABLET_MAX_WIDTH = LAPTOP_MIN_WIDTH - 1
export const MOBILE_MAX_WIDTH = TABLET_MIN_WIDTH - 1
export const XXL_BREAKPOINT = 1400
export const LAPTOP_BREAKPOINT = XXL_BREAKPOINT
export const XL_BREAKPOINT = 1200
